import { clamp } from '@visiba/std';
import type { CaseOtherApiModel } from '@api_patient/generated/clientv2/models';

export interface Issues {
	readonly totalCount: number;
	readonly awaitPayment: number;
	readonly unreadMessages: number;
	readonly awaitFormResponses: number;
	readonly isNewCase: boolean;
}

export abstract class CaseModelShared<T = unknown> {
	constructor() {
		// Empty
	}

	abstract updateLesserData(caseData: CaseOtherApiModel): void;
	abstract get(): T;
	abstract getIdentifier(): string | number;

	protected parseIssues(caseData: CaseOtherApiModel): Issues {
		let unreadMessages = 0;
		let awaitFormResponses = 0;
		let awaitPayment = 0;
		let isNewCase = 0;
		for (const issue of caseData.UnhandledIssues) {
			if (issue === 'UnreadMessages') {
				unreadMessages++;
				continue;
			}

			if (issue === 'AwaitingFormResponse') {
				awaitFormResponses++;
				continue;
			}

			if (issue === 'AwaitingPayment') {
				awaitPayment++;
				continue;
			}

			if (issue === 'NewIncoming') {
				isNewCase = 1;
			}
		}

		return {
			totalCount: clamp(unreadMessages + awaitFormResponses + awaitPayment + isNewCase, [0, Infinity]),
			isNewCase: !!isNewCase,
			awaitPayment: clamp(awaitPayment, [0, Infinity]),
			unreadMessages: clamp(unreadMessages, [0, Infinity]),
			awaitFormResponses: clamp(awaitFormResponses, [0, Infinity]),
		};
	}
}
